<template>
  <div class="calculator" :id="calculatorName">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-10 col-xl-8 mb-3">
          <div class="progress-container">
          <div class="progress-bar-bg">
            <div class="progress-bar-fill" :style="{ width: ((currentStep - 1) / (totalSteps - 1)) * 100 + '%' }"></div>
          </div>
        </div>

        <div class="step-nav-buttons mt-4 text-center">
              <button
                type="button"
                class="btn previous-step"
                @click="prevStep"
                v-if="currentStep != 1"
              >
                Back
              </button>
        </div>

        
        <div class="calculator-container">

          <div class="mt-3" @keyup="resetCalculation" @change="resetCalculation">

            <BooleanChoiceButtons
                fieldText="Number of applicants"
                buttonTextLeft="1"
                buttonTextRight="2"
                v-if="currentStep === 1"
            >
              <template v-slot:left>
                <input type="radio" name="applicantCount" v-model="applicantsCount" :value="1">
              </template>
              <template v-slot:right>
                <input type="radio" name="applicantCount" v-model="applicantsCount" :value="2">
              </template>
            </BooleanChoiceButtons>

            <div v-if="currentStep === 2">
              <h4 class="calc-fieldset-title">Applicant Details</h4>
              <InputElement
                  
                  fieldText="Applicant 1 annual income (including benefits)?"
              >
                <InputTypeNumber currencyPlaceholder v-model="annualIncome1"/>
              </InputElement>
            </div>

            <div v-if="currentStep === 3">
              <h4 class="calc-fieldset-title">Applicant Details</h4>
              <InputElement
                  
                  fieldText="Applicant 2 annual income (including benefits)?"
              >
                <InputTypeNumber currencyPlaceholder v-model="annualIncome2"/>
              </InputElement>
            </div>

            <div v-if="currentStep === 4">
              <h4 class="calc-fieldset-title">Property Details</h4>
              <InputElement
                  
                  fieldText="What is the property purchase price or valuation?"
              >
                <InputTypeNumber currencyPlaceholder v-model="housePrice"/>
              </InputElement>
            </div>

            <div v-if="currentStep === 5">
              <h4 class="calc-fieldset-title">Property Details</h4>
              <InputElement
                  
                  fieldText="How much do you need to borrow?"
              >
                <InputTypeNumber currencyPlaceholder v-model="amountToBorrow"/>
              </InputElement>
            </div>

            <div v-if="currentStep === 6">
              <BooleanChoiceButtons
                  fieldText="Do you have a repayment strategy?"
                  buttonTextLeft="Yes"
                  buttonTextRight="No"
              >
                <template v-slot:left>
                  <input type="radio" v-model="repaymentStrategy" value="Yes">
                </template>
                <template v-slot:right>
                  <input type="radio" v-model="repaymentStrategy" value="No">
                </template>
              </BooleanChoiceButtons>
            </div>

            <div class="row mb-5" v-if="currentStep === 7">
              <div class="col-12 booleanLabel">Why are you using the calculator today?</div>
              <div class="col-12 row calc-right-buttons-wrapper">
                <MultiplyChoiceButton
                    buttonText="I’m ready to get a mortgage"
                >
                  <input type="radio" v-model="calcReason1" value="I’m ready to get a mortgage">
                </MultiplyChoiceButton>
                <MultiplyChoiceButton
                    buttonText="I’m curious to know what I can borrow"
                >
                  <input type="radio" v-model="calcReason1" value="I’m curious to know what I can borrow">
                </MultiplyChoiceButton>
                <MultiplyChoiceButton
                    buttonText="I want to understand what I can afford before I search for a home"
                >
                  <input type="radio" v-model="calcReason1" value="I want to understand what I can afford before I search for a home">
                </MultiplyChoiceButton>
                </div>
            </div>

            <div class="row mb-5" v-if="currentStep === 8">
              <div class="col-12 booleanLabel">When are you hoping to move?</div>
              <div class="col-12 row calc-right-buttons-wrapper">
                <MultiplyChoiceButton
                    buttonText="As soon as possible"
                >
                  <input type="radio" v-model="calcReason2" value="As soon as possible">
                </MultiplyChoiceButton>
                <MultiplyChoiceButton
                    buttonText="In the next 3 months"
                >
                  <input type="radio" v-model="calcReason2" value="In the next 3 months">
                </MultiplyChoiceButton>
                <MultiplyChoiceButton
                    buttonText="6-12 months from now"
                >
                  <input type="radio" v-model="calcReason2" value="6-12 months from now">
                </MultiplyChoiceButton>
                <MultiplyChoiceButton
                    buttonText="12+ months from now"
                >
                  <input type="radio" v-model="calcReason2" value="12+ months from now">
                </MultiplyChoiceButton>
                </div>
            </div>

            <div class="step-nav-buttons mt-4 text-center">
              <button
                type="button"
                class="btn next-step"
                @click="nextStep"
                v-if="currentStep != totalSteps - 1 && currentStep != 9"
                :disabled="!isStepValid"
              >
                Continue
              </button>

              <button
                type="button"
                class="btn calculate"
                v-if="currentStep === totalSteps - 1"
                @click="calculate"
                :disabled="!isStepValid"
              >
                Calculate
              </button>
            </div>

          </div>

          <div v-if="currentStep === 9" ref="resultsContainer">

            <ResultsContainer class="mt-5 mb-5 calc-results-box">
              <div class="mb-3 results-title">Your estimated maximum borrowing amount is: approximately</div>
              <span class="fcs-price">£{{ formatNumberOutput(potentialLoanAmount) }}</span>
              <div class="mt-3">{{ this.chance }}</div>
            </ResultsContainer>

            <SubmissionForm :calculatorName="calculatorName" :calculatorData="collateMessageBody"/>

          </div>

        </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BooleanChoiceButtons from '@/components/utilities/booleanChoiceButtons.vue'
import InputElement from '@/components/utilities/inputElement.vue'
import InputTypeNumber from '@/components/utilities/inputTypeNumber.vue'
import MultiplyChoiceButton from '@/components/utilities/multiplyChoiceButton.vue'
import ResultsContainer from '@/components/utilities/resultsContainer.vue'
import SubmissionForm from '@/components/utilities/submissionForm.vue'
import axios from "axios"

export default {
  components: {
    BooleanChoiceButtons,
    InputElement,
    InputTypeNumber,
    MultiplyChoiceButton,
    ResultsContainer,
    SubmissionForm
  },
  data() {
    return {
      currentStep: 1,
      totalSteps: 9,
      calculatorName: 'interest-only-calculator',
      applicantsCount: null,
      annualIncome1: 0,
      annualIncome2: 0,
      housePrice: 0,
      amountToBorrow: null,
      repaymentStrategy: null,
      potentialLoanAmount: 0,
      chance: '',
      calcCompleted: false,
      calculatorReasonTitle: null,
      calculatorReasonResults: null,
      calcReason1: "",
      calcReason2: "",
      listName: "",
      emailAddress: "",
      consent: "",
      
      submissionReason: {
        submitted: false,
        is_valid: false,
        confirmation_message: ''
      },
      submissionList: {
        submitted: false,
        is_valid: false,
        confirmation_message: ''
      },
      formErrors: [],
      gfid: 6, //Please check the Gravity Form for corresponding form id (staging and live may vary!)
      gfidlist: 9 //Please check the Gravity Form for corresponding form id (staging and live may vary!)
    }
  },
  methods: {
    calculate() {
      if (this.currentStep < this.totalSteps) {
        this.currentStep++;
      }
      this.potentialLoanAmount = this.householdIncome * 5.5

      if( (this.loanToValue < 75) && (this.equity >= 100000) && (this.annualIncome1 >= 50000 || this.annualIncome2 >= 50000) ) {
        this.chance = `You've got a very good chance of getting an Interest Only Mortgage, contact us for further details`;
      }
      if( ((this.loanToValue < 75) && (this.equity >= 100000)) || (this.equity >= 100000 && (this.annualIncome1 >= 50000 || this.annualIncome2 >= 50000)) ) {
        this.chance = `You've got a good chance of getting an Interest Only Mortgage, contact us for further details.`;
      }
      if( (this.loanToValue < 75) || (this.equity >= 100000) ) {
        this.chance = `We may be able to get you an Interest Only Mortgage, contact us for further details.`;
      }
      if( (this.annualIncome1 >= 50000 || this.annualIncome2 >= 50000) || this.loanToValue > 75 ) {
        this.chance = `Please submit your details below to obtain your most suitable Interest Only mortgage advice and the most suitable rates.`;
      }
      this.calcCompleted = true;
      this.calculatorReasonTitle = this.removeHyphensToUpperCase(this.calculatorName);
      this.calculatorReasonResults = 
      `
      Why are you using the calculator today: ${this.calcReason1}
      When will you be ready to move forward: ${this.calcReason2}
      `;
      this.$nextTick(() => {
                const resultsContainer = this.$refs.resultsContainer;

                if (resultsContainer) {
                    // Get the bounding rectangle of the element
                    const rect = resultsContainer.getBoundingClientRect();

                    // Calculate the target scroll position
                    const targetScrollPosition = window.scrollY + rect.top - 200;

                    // Scroll to the target position
                    window.scrollTo({
                        top: targetScrollPosition,
                        behavior: 'smooth'
                    });
                } else {
                    console.error('resultsContainer is undefined');
                }
            });
      var newReasonSubmission = new FormData();
      var newListSubmission = new FormData();


      newReasonSubmission.append("form_id", this.gfid); //Please check the Gravity Form form id (staging and live may vary!)
      newReasonSubmission.append("input_1", this.calculatorReasonTitle);
      newReasonSubmission.append("input_3", this.calculatorReasonResults);

      newListSubmission.append("form_id", this.gfidlist); //Please check the Gravity Form form id (staging and live may vary!)
      newListSubmission.append("input_1", this.calculatorListName);
      newListSubmission.append("input_3", this.calculatorEmailAddress);
      newListSubmission.append("input_4.1", this.calculatorConsent ? 1 : 0);

      this.postReasonSubmission(newReasonSubmission);
      this.postListSubmission(newListSubmission);
    },
    async postReasonSubmission(submissionReasonData) {
      try {
        const response = axios.post('/wp-json/gf/v2/forms/8/submissions', submissionReasonData, {
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        });
        const submissionReason = response;
        
        this.submissionReason.is_valid = submissionReason.is_valid;
        this.submissionReason.confirmation_message = submissionReason.confirmation_message;
        this.submissionReason.validation_messages = submissionReason.validation_messages;

      } catch(error) {
        console.log(error)
      }
    },
    async postListSubmission(submissionListData) {
      try {
        const response = axios.post('/wp-json/gf/v2/forms/9/submissions', submissionListData, {
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        });
        const submissionList = response;
        
        this.submissionList.is_valid = submissionList.is_valid;
        this.submissionList.confirmation_message = submissionList.confirmation_message;
        this.submissionList.validation_messages = submissionList.validation_messages;

      } catch(error) {
        console.log(error)
      }
    },
    formatNumberOutput(number) {
      const newNumber = (new Intl.NumberFormat('en-GB').format(number))
      if ( newNumber === 'NaN' ) { return 0 } return newNumber
    },
    removeHyphensToUpperCase(str) {
      return str.replace(/(-|^)([^-]?)/g, function(_, prep, letter) { return (prep && ' ') + letter.toUpperCase(); });
    },
    resetCalculation() {
      this.calcCompleted = false;
    },
    clearApplicant2() {
      this.annualIncome2 = ''
    },
    formatEmptyMessageFields(message){
      return message ? message : 'N/A'
    },
    nextStep() {
      if (this.currentStep === 2 && this.applicantsCount === 1) {
        this.currentStep = 4;
      } else if (this.currentStep < this.totalSteps) {
        this.currentStep++;
      }
    },
    prevStep() {
      if (this.currentStep === 4 && this.applicantsCount === 1) {
        this.currentStep = 2;
      } else if (this.currentStep === 9) {
        this.currentStep = 8;
      } else if (this.currentStep < this.totalSteps) {
        this.currentStep--;
      }
    },
  },
  computed: {
    /**
     * Check if previous logical section is completed
     * @return {Bool}
     */
    sectionCompleted() {
      let sectionCompleted
      if ( !this.applicantsCount ) { sectionCompleted = false }
      this.applicantsCount == 2
          ? ( this.annualIncome1 > 0 && this.annualIncome2 > 0 ) ? sectionCompleted = true : sectionCompleted = false
          : this.annualIncome1 > 0 ? sectionCompleted = true : sectionCompleted = false
      return sectionCompleted
    },
    /**
     * Calculate the total income for the household
     * @return {Number}
     */
    isStepValid() {
      if (this.currentStep === 1) {
        return this.applicantsCount === 1 || this.applicantsCount === 2;
      }
      if (this.currentStep === 2) {
        return this.annualIncome1 != null;
      }
      if (this.currentStep === 3) {
        return this.annualIncome2 != null;
      }
      if (this.currentStep === 4) {
        return this.housePrice != null;
      }
      if (this.currentStep === 5) {
        return this.amountToBorrow != null;
      }
      if (this.currentStep === 6) {
        return this.repaymentStrategy === 'Yes' || this.repaymentStrategy === 'No';
      }
      if (this.currentStep === 7) {
        return this.calcReason1 != null;
      }
      if (this.currentStep === 8) {
        return this.calcReason2 != null;
      }
      return true;
    },
    householdIncome() {
      let annualIncome1 = this.annualIncome1 ? this.annualIncome1 : 0;
      let annualIncome2 = this.annualIncome2 ? this.annualIncome2 : 0;

      return annualIncome1 + annualIncome2;
    },
    equity() {
      let borrowAmount = this.amountToBorrow ? this.amountToBorrow : 0;
      let housePrice = this.housePrice ? this.housePrice : 0;
      return housePrice - borrowAmount;
    },
    loanToValue() {
      let borrowAmount = this.amountToBorrow ? this.amountToBorrow : 0;
      let housePrice = this.housePrice ? this.housePrice : 0;
      return (borrowAmount / housePrice) * 100;
    },
    collateMessageBody() {
      let calculatorData = {
        calculatorTitle: this.removeHyphensToUpperCase(this.calculatorName),
        calculatorResults:
            `
					Number of applicants: ${this.applicantsCount}
					Applicant 1 income: £${this.annualIncome1}
					Applicant 2 income: £${this.formatEmptyMessageFields(this.annualIncome2)}
					Household income: £${this.householdIncome}
					
					Property value: £${this.housePrice}
					How much do you need to borrow? £${this.amountToBorrow}
                    Do you have a repayment strategy? ${this.repaymentStrategy}
					Potentinal value of loan: £${this.potentialLoanAmount}
					Loan to value: £${this.loanToValue}
                    Equity available: £${this.equity}
                    Why are you using the calculator today: ${this.calcReason1}
          When will you be ready to move forward: ${this.calcReason2}
				`
      }

      return calculatorData;
    }
  }
}
</script>

<style lang="scss">
@import './styles/calcs.scss';
</style>